// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2NK4i","vLegacy":"SelectSecondary_vLegacy__3JfmA","error":"SelectSecondary_error__12p93","disabled":"SelectSecondary_disabled__1OIm1"};